import React, { useState } from "react";
import Modal from "../shared/Modal";
import ActionButton from "../common/ActionButton";
import "./ModalSaveToDocuments.css";
import { Button } from "../../ds2/components";

export interface ModalSaveToDocumentsProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (title: string, description: string) => void;
  isLoading: boolean;
  defaultTitle?: string;
}

export const ModalSaveToDocuments: React.FC<ModalSaveToDocumentsProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading,
  defaultTitle = "",
}) => {
  const [title, setTitle] = useState(defaultTitle);
  const [description, setDescription] = useState("");

  React.useEffect(() => {
    if (isOpen) {
      setTitle(defaultTitle);
      setDescription("");
    }
  }, [isOpen, defaultTitle]);

  const handleSave = () => {
    if (!title.trim()) return;
    onSave(title.trim(), description.trim());
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && e.metaKey && title.trim()) {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} style={{}}>
      <div className="modal-save-to-documents">
      <div className="modal-save-to-documents-header">
        <h2>Save to Documents</h2>
      </div>

      <div className="modal-save-to-documents-body">
        <div className="modal-save-to-documents-input-container">
          <input
            type="text"
            placeholder="Enter document title..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyPress={handleKeyPress}
            className="modal-save-to-documents-input"
            autoFocus
          />
        </div>

        <div className="modal-save-to-documents-input-container">
          <input
            type="text"
            placeholder="Enter description (optional)..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onKeyPress={handleKeyPress}
            className="modal-save-to-documents-input"
          />
        </div>

        <p className="modal-save-to-documents-hint">
          This will generate a PDF from your document and save it to your workspace.
        </p>
      </div>

      <div className="modal-save-to-documents-footer">
        <Button 
          label="Cancel"
          variant="tertiary" 
          onClick={onClose}
          disabled={isLoading}
        />

        <Button
          label={isLoading ? "Saving..." : "Save to Documents"}
          variant="primary"
          onClick={handleSave}
          disabled={!title.trim() || isLoading}
        />
      </div>
      </div>
    </Modal>
  );
};